"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHero2ViewRight = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const components_1 = require("./components");
const Img = (0, app_1.styled)(app_1.Image) `
  height: unset;
`;
function ProductHero2ViewRight({ product, }) {
    const isMobile = (0, app_1.useContextPath)('isMobile');
    const productPath = (0, app_1.useContextPath)('ecommerce.product');
    const images = isMobile ? product.images.slice(0, 1) : product.images;
    return ((0, jsx_runtime_1.jsx)(components_1.RightPanel, Object.assign({ "$single": images.length === 1 }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(app_1.AssetsProvider, Object.assign({ path: `${productPath}/${product.id}` }, { children: images.map((image) => ((0, jsx_runtime_1.jsx)(Img, { img: image, layout: "responsive", aspectRatio: true }, image.name))) })) }) })));
}
exports.ProductHero2ViewRight = ProductHero2ViewRight;
